module.exports = __webpack_public_path__ + "media/images/lb/806-09fc157dc5921f18ee4a37ad42409dac.svg";